/* auto-size-details.js — wrap first size table into a <details> */
document.addEventListener('DOMContentLoaded', () => {
  /* 1. 描述区元素选择器：Dawn 8+ 用 data-product-description */
  const desc = document.querySelector('[data-product-description], .product__description');
  if (!desc) return;

  /* 2. 找出第一张包含 cm 或 inch 的表格 */
  const sizeTable = Array.from(desc.querySelectorAll('table'))
    .find(tbl => /cm|inch/i.test(tbl.textContent));
  if (!sizeTable) return;

  /* 3. 已经折叠过就跳过，避免二次包裹 */
  if (sizeTable.closest('details')) return;

  /* 4. 创建 <details> 壳 */
  const details = document.createElement('details');
  details.className = 'size-guide';
  const summary = document.createElement('summary');
  summary.innerHTML = '<strong>📏 Size Guide (cm/inch)▼</strong>';
  details.appendChild(summary);

  /* 5. 把表格移进去并插回文档流 */
  sizeTable.parentNode.insertBefore(details, sizeTable);
  details.appendChild(sizeTable);
});
